<template>
  <div class="page-home">
    <b-modal
        :title="$t('Utilities')"
        v-model="show"
        dialog-class="trans-modal bg-app page-home"
        :hide-footer="true"
        size="lg"
        no-close-on-backdrop lazy>
      <div class="buttons text-center" style="padding-top: 0">
        <MainButton v-for="(button, key) in buttons" :key="key" :data="button" @click="buttonClicked"/>
      </div>
    </b-modal>
    <PanelLoading :show="loading"/>
    <OfflineParticipantsModal ref="offlineParticipantsModal"/>
    <MeetingSettingsModal ref="meetingSettingsModal"/>
    <MeetingSchedulesModal ref="meetingSchedulesModal" />
    <ParticipantsModal ref="participantsModal" />
  </div>
</template>

<script>
import MainButton from "../components/MainButton";
import OfflineParticipantsModal from "./OfflineParticipantsModal";
import MeetingSettingsModal from "./MeetingSettingsModal";
import MeetingSchedulesModal from "./MeetingSchedulesModal";
import ParticipantsModal from "./ParticipantsModal";
import meetingService from "../services/meeting_service";
import dialogHelper from "../helpers/dialog_helper";

export default {
  name: "UtilitiesModal",
  components: {MainButton, OfflineParticipantsModal, MeetingSettingsModal, MeetingSchedulesModal, ParticipantsModal},
  data: function () {
    return {
      show: false,
      loading: false,
      buttons: []
    }
  },
  methods: {
    async open() {
      this.loading = true;
      let response = await meetingService.utilities();
      this.loading = false;
      if (!response)
        return;

      if (!response.startsWith("OK|")) {
        dialogHelper.alert(response, "error");
        return;
      }

      let arr = response.substr(3).split('|');
      let button = this.buttons.find(x => x.key === "MeetingSchedules");
      if (button != null) button.disabled = arr[0] === "1";
      this.show = true;
    },
    buttonClicked(data) {
      if (data && data.key) {
        switch (data.key) {
          case "Participants":
            this.show = false;
            this.$refs.participantsModal.open();
            break;
          case "OfflineParticipants":
            this.show = false;
            this.$refs.offlineParticipantsModal.open();
            break;
          case "MeetingSettings":
            this.show = false;
            this.$refs.meetingSettingsModal.open();
            break;
          case "MeetingSchedules":
            this.show = false;
            this.$refs.meetingSchedulesModal.open();
            break;
        }
      }
    }
  },
  created() {
    let buttons = this.$store.getters.mainButtons;
    let keys = Object.keys(buttons);
    this.buttons = [{
      key: "Participants",
      name: keys.includes("Participants") ? buttons["Participants"] : this.$t("Participants"),
      icon: "images/ico-users.png"
    }, {
      key: "OfflineParticipants",
      name: this.$t("Offline participants"),
      icon: "images/ico-check-user.png"
    }, {
      key: "MeetingSettings",
      name: this.$t("Meeting settings"),
      icon: "images/ico-tools.png"
    }, {
      key: "MeetingSchedules",
      name: this.$t("Meeting schedules"),
      icon: "images/ico-calendar.png",
      disabled: false
    }];
  }
}
</script>

<style scoped>

</style>